"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = inputComponent;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _reactSelect = require("react-select");
var _excluded = ["innerProps", "selectProps"];
// eslint-disable-next-line react/prop-types
function inputComponent(_ref) {
  var innerProps = _ref.innerProps,
    selectProps = _ref.selectProps,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_reactSelect.components.Input, (0, _extends2["default"])({}, props, {
    maxLength: selectProps.maxLength,
    "data-metrics": selectProps.dataMetrics.input
  }));
}